module.exports = __webpack_public_path__ + "img/Foggy.54041998.png";